import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5a460a15&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5a460a15&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a460a15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a460a15')) {
      api.createRecord('5a460a15', component.options)
    } else {
      api.reload('5a460a15', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5a460a15&scoped=true", function () {
      api.rerender('5a460a15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MyComponents/index.vue"
export default component.exports